module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/pescara.1b31d880ffe5f161a1dd193c04024c18.jpg";